/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const SparklinePoint = zod
	.object({
		cases: zod.number().describe('Cases on this day'),
		day: zod.iso.date().describe('Calendar date')
	})
	.describe('Daily sparkline data point');

export type SparklinePoint = zod.input<typeof SparklinePoint>;
export type SparklinePointOutput = zod.output<typeof SparklinePoint>;
